"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startStream = exports.injectStreamToDom = exports.removeDropzone = exports.createDropzone = exports.getFoldersForUploadPromise = exports.getFoldersForUpload = exports.getFilesForUploadPromise = exports.getFilesForUpload = exports.upload = exports.download = exports.removeTransfer = exports.cancelTransfer = exports.clearNonActiveTransfers = exports.getAllTransfers = exports.getTransferById = exports.deregisterActivityCallback = exports.registerActivityCallback = exports.testHttpGatewayConnection = exports.initHttpGateway = exports.asperaHttpGateway = void 0;
require('es6-promise').polyfill();
var http_gateway_global_model_1 = require("./models/http-gateway-global.model");
var core_1 = require("./app/core");
var download_1 = require("./app/download");
var upload_1 = require("./app/upload");
var streaming_1 = require("./app/streaming");
exports.asperaHttpGateway = new http_gateway_global_model_1.HttpGateway();
exports.asperaHttpGateway.initHttpGateway = core_1.initHttpGateway;
exports.asperaHttpGateway.testHttpGatewayConnection = core_1.testHttpGatewayConnection;
exports.asperaHttpGateway.download = download_1.download;
exports.asperaHttpGateway.upload = upload_1.upload;
exports.asperaHttpGateway.getFilesForUpload = upload_1.getFilesForUpload;
exports.asperaHttpGateway.getFilesForUploadPromise = upload_1.getFilesForUploadPromise;
exports.asperaHttpGateway.getFoldersForUpload = upload_1.getFoldersForUpload;
exports.asperaHttpGateway.getFoldersForUploadPromise = upload_1.getFoldersForUploadPromise;
exports.asperaHttpGateway.createDropzone = upload_1.createDropzone;
exports.asperaHttpGateway.removeDropzone = upload_1.removeDropzone;
exports.asperaHttpGateway.registerActivityCallback = core_1.registerActivityCallback;
exports.asperaHttpGateway.deregisterActivityCallback = core_1.deregisterActivityCallback;
exports.asperaHttpGateway.getTransferById = core_1.getTransferById;
exports.asperaHttpGateway.getAllTransfers = core_1.getAllTransfers;
exports.asperaHttpGateway.clearNonActiveTransfers = core_1.clearNonActiveTransfers;
exports.asperaHttpGateway.removeTransfer = core_1.removeTransfer;
exports.asperaHttpGateway.cancelTransfer = core_1.cancelTransfer;
exports.asperaHttpGateway.startStream = streaming_1.startStream;
exports.asperaHttpGateway.injectStreamToDom = streaming_1.injectStreamToDom;
if (typeof window === 'object') {
    window.onbeforeunload = exports.asperaHttpGateway.checkForPageLeave;
    window.addEventListener('beforeunload', exports.asperaHttpGateway.checkForPageLeave);
    window.asperaHttpGateway = exports.asperaHttpGateway;
}
var core_2 = require("./app/core");
Object.defineProperty(exports, "initHttpGateway", { enumerable: true, get: function () { return core_2.initHttpGateway; } });
Object.defineProperty(exports, "testHttpGatewayConnection", { enumerable: true, get: function () { return core_2.testHttpGatewayConnection; } });
Object.defineProperty(exports, "registerActivityCallback", { enumerable: true, get: function () { return core_2.registerActivityCallback; } });
Object.defineProperty(exports, "deregisterActivityCallback", { enumerable: true, get: function () { return core_2.deregisterActivityCallback; } });
Object.defineProperty(exports, "getTransferById", { enumerable: true, get: function () { return core_2.getTransferById; } });
Object.defineProperty(exports, "getAllTransfers", { enumerable: true, get: function () { return core_2.getAllTransfers; } });
Object.defineProperty(exports, "clearNonActiveTransfers", { enumerable: true, get: function () { return core_2.clearNonActiveTransfers; } });
Object.defineProperty(exports, "cancelTransfer", { enumerable: true, get: function () { return core_2.cancelTransfer; } });
Object.defineProperty(exports, "removeTransfer", { enumerable: true, get: function () { return core_2.removeTransfer; } });
var download_2 = require("./app/download");
Object.defineProperty(exports, "download", { enumerable: true, get: function () { return download_2.download; } });
var upload_2 = require("./app/upload");
Object.defineProperty(exports, "upload", { enumerable: true, get: function () { return upload_2.upload; } });
Object.defineProperty(exports, "getFilesForUpload", { enumerable: true, get: function () { return upload_2.getFilesForUpload; } });
Object.defineProperty(exports, "getFilesForUploadPromise", { enumerable: true, get: function () { return upload_2.getFilesForUploadPromise; } });
Object.defineProperty(exports, "getFoldersForUpload", { enumerable: true, get: function () { return upload_2.getFoldersForUpload; } });
Object.defineProperty(exports, "getFoldersForUploadPromise", { enumerable: true, get: function () { return upload_2.getFoldersForUploadPromise; } });
Object.defineProperty(exports, "createDropzone", { enumerable: true, get: function () { return upload_2.createDropzone; } });
Object.defineProperty(exports, "removeDropzone", { enumerable: true, get: function () { return upload_2.removeDropzone; } });
var streaming_2 = require("./app/streaming");
Object.defineProperty(exports, "injectStreamToDom", { enumerable: true, get: function () { return streaming_2.injectStreamToDom; } });
Object.defineProperty(exports, "startStream", { enumerable: true, get: function () { return streaming_2.startStream; } });
exports.default = {
    asperaHttpGateway: exports.asperaHttpGateway,
    initHttpGateway: core_1.initHttpGateway,
    testHttpGatewayConnection: core_1.testHttpGatewayConnection,
    download: download_1.download,
    upload: upload_1.upload,
    getFilesForUpload: upload_1.getFilesForUpload,
    getFilesForUploadPromise: upload_1.getFilesForUploadPromise,
    getFoldersForUpload: upload_1.getFoldersForUpload,
    getFoldersForUploadPromise: upload_1.getFoldersForUploadPromise,
    createDropzone: upload_1.createDropzone,
    removeDropzone: upload_1.removeDropzone,
    registerActivityCallback: core_1.registerActivityCallback,
    deregisterActivityCallback: core_1.deregisterActivityCallback,
    getTransferById: core_1.getTransferById,
    getAllTransfers: core_1.getAllTransfers,
    clearNonActiveTransfers: core_1.clearNonActiveTransfers,
    removeTransfer: core_1.removeTransfer,
    cancelTransfer: core_1.cancelTransfer,
    startStream: streaming_1.startStream,
    injectStreamToDom: streaming_1.injectStreamToDom
};
